/** @file treeBindings: the node tree's key table (context `tree`, `event.code` chords). */
import type { Binding } from '@zilo/pose3d-shortcuts/types';

const t = (id: string, keys: string): Binding => ({ id, keys, context: 'tree' });

/**
 * Arrows move / collapse / expand, F2 renames, F frames, M pairs mirror twins, Delete removes the node (after a
 * confirm), H hides the selection in the viewport (view only), Alt+H shows all, Alt+1..7 toggles the group chip,
 * Alt+0 clears the search and chips.
 */
export const treeBindings: Binding[] = [
  t('tree.selectPrev', 'ArrowUp'), t('tree.selectNext', 'ArrowDown'), t('tree.collapse', 'ArrowLeft'), t('tree.expand', 'ArrowRight'),
  t('tree.rename', 'F2'), t('tree.frame', 'KeyF'), t('tree.mirrorPair', 'KeyM'), t('tree.remove', 'Delete'),
  t('tree.viewHide', 'KeyH'), t('tree.viewShowAll', 'Alt+Shift+KeyH'),
  ...[1, 2, 3, 4, 5, 6, 7].map((n) => t(`tree.group${n}`, `Alt+Digit${n}`)),
  t('tree.clearFilters', 'Alt+Digit0'),
];
